import { observer } from 'mobx-react-lite'
import { ReactElement, useEffect } from 'react'
import BaseDrawer from '../../../ui-components/modals/BaseDrawer'
import { create as createNiceModal, useModal } from '@ebay/nice-modal-react'
import DrawerBody from './DrawerBody'
import DrawerFooter from './DrawerFooter'
import DrawerHeader from './DrawerHeader'
import { breakpoints } from '../../../theme/breakpoints'
import { isMobile } from 'react-device-detect'
import { DrawerSizes } from '../../../theme/drawer-size'
import { Vehicle } from '../../../store/models/Vehicles'
import { ProductModel } from 'interfaces'
import { useLocation } from 'react-router-dom'
import { formatVehicleDisplayWithOutEngine } from 'src/helpers/utils'

interface LaborLookupDrawerProps {
  vehicle: Vehicle
  product?: ProductModel
  setLaborResult: (laborResult: boolean) => void
}

const LaborLookupDrawer = createNiceModal<LaborLookupDrawerProps>(
  observer(
    ({
      vehicle,
      product,
      setLaborResult,
    }: LaborLookupDrawerProps): ReactElement => {
      const location = useLocation()
      const currentPathname = location?.pathname
      const modal = useModal()
      // const { currentVehicle: vehicle } = useSearchStore()
      const handleClose = () => {
        modal.remove()
      }

      const yearMakeModel = formatVehicleDisplayWithOutEngine(vehicle)
      const engine = vehicle?.engine?.value || ''

      const header = (
        <DrawerHeader
          {...{ yearMakeModel, engine }}
          title={'laborLookup'}
          onClose={handleClose}
        />
      )

      const body = <DrawerBody partGroupId={product?.group?.id} />

      const footer = (
        <DrawerFooter setLaborResult={setLaborResult} modal={modal} />
      )

      const showDividerLines = {
        showHeaderDivider: true,
        showFooterDivider: true,
      }

      useEffect(() => {
        if (currentPathname === '/cart') {
          handleClose()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [currentPathname])

      return (
        <BaseDrawer
          open={modal.visible}
          title={''}
          header={isMobile ? null : header}
          body={body}
          footer={footer}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onClose={() => {}}
          {...showDividerLines}
          width={'240px'}
          height={
            window.innerWidth < breakpoints.tabletXLarge ? '90vh' : '100%'
          }
          minWidth={
            window.innerWidth < breakpoints.tabletXLarge
              ? '100%'
              : DrawerSizes.medium
          }
          manageScrollLock
        />
      )
    }
  )
)

export default LaborLookupDrawer
